import SearchIcon from '@mui/icons-material/Search'
import { useState, ChangeEvent, FC, useEffect, useRef } from 'react'
import { IconButton, styled, TextField } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import theme from '@/utilities/Theme'
import { Close } from '@mui/icons-material'

const SearchTextField = styled(TextField)(() => ({
  backgroundColor: '#fff',
  width: '406px',
  borderRadius: '8px',
  border: '1px solid #FFF',
  '@media (max-width: 600px)': {
    maxWidth: '100%',
  },
  '& .MuiOutlinedInput-root': {
    height: '48px',
    borderRadius: '8px',
    padding: '0 0 0 3%',
    border: 'none',
  },
  '& .MuiInputBase-input': {
    height: '100%',
    boxSizing: 'border-box',
  },
  '& .MuiInputBase-input::placeholder': {
    fontSize: '14px',
    color: '#AEB6CF',
    fontWeight: 400,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  [theme.breakpoints.down('md')]: {
    width: '98%',
  },
}))

type SearchbarProps = {
  handleSearchKeyword: (keyword: string) => void
  keyword: string
}

export const Searchbar: FC<SearchbarProps> = ({
  handleSearchKeyword,
  keyword,
}) => {
  const location = useLocation()
  const navigate = useNavigate()
  const params = new URLSearchParams(location.search)
  const ticketNo = params.get('ticketNo')
  // const isProcessed = params.get('isProcessed')
  const [value, setValue] = useState(keyword)
  const initializedWithTicketNo = useRef(false)

  useEffect(() => {
    if (ticketNo && !initializedWithTicketNo.current) {
      setValue(ticketNo)
      // handleSearchKeyword(ticketNo, isProcessed === 'true')
      initializedWithTicketNo.current = true
    }
  }, [])

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value
    setValue(input)
    handleSearchKeyword(input)

    if (ticketNo) {
      const newParams = new URLSearchParams(location.search)
      newParams.delete('ticketNo')
      newParams.delete('isProcessed')
      navigate(
        {
          pathname: location.pathname,
          search: newParams.toString(),
        },
        { replace: true },
      )
    }
  }

  return (
    <SearchTextField
      value={value || ''}
      placeholder="Search"
      variant="outlined"
      size="small"
      onChange={handleSearch}
      InputProps={{
        startAdornment: (
          <SearchIcon
            style={{ width: '24px', height: '24px', color: '#AEB6CF' }}
          />
        ),
        endAdornment: value && (
          <IconButton
            size="small"
            onClick={() => {
              setValue('')
              handleSearchKeyword('')

              // Remove ticketNo param when clearing search
              const newParams = new URLSearchParams(location.search)
              newParams.delete('ticketNo')
              navigate(
                {
                  pathname: location.pathname,
                  search: newParams.toString(),
                },
                { replace: true },
              )
            }}
            sx={{ padding: 0, marginRight: 1 }}
          >
            <Close style={{ color: '#AEB6CF' }} />
          </IconButton>
        ),
      }}
    />
  )
}
